// ==========================================
// 🔥 热榜新闻池 (News / Hot Trends)
// ==========================================
export const newsPool = [
    // 固定的时间线新闻
    {
        condition: (state) => state.round === 1,
        content: {
            id: 'n_start',
            title: "🔥 【置顶】AI 时代全面降临，初级码农何去何从？",
            views: "230w", comments: 888,
            choices: [
                { text: "AI 必将替代人类，早点转行吧。", effect: { tech: +5, publicOpinion: -10 } },
                { text: "大家别慌，AI 只是辅助工具。", effect: { stability: +5, publicOpinion: +10 } }
            ]
        }
    },
    {
        condition: (state) => state.round === 2 && state.model === 'capital',
        content: { id: 'n_f_cap', title: "🔥 震惊！某公司估值百亿的 AI 项目，实为外包人工手写！", views: "300w", comments: 10000 }
    },
    {
        condition: (state) => state.round === 3,
        content: { id: 'n_r3', title: "🔥 ChatGPT 能帮我写年终总结吗？", views: "88w", comments: 120 }
    },
    {
        condition: (state) => state.round === 6,
        content: { id: 'n_r6', title: "🚨 突发：著名极客论坛 StackOverflow 流量暴跌 80%", views: "210w", comments: 880 }
    },

    // 动态数值触发新闻
    {
        condition: (state) => state.tech >= 80,
        content: { id: 'n_tech_80', title: "🔥 震惊！某厂新任 CTO 竟是一个 AI 模型", views: "650w", comments: 12000 }
    },
    {
        condition: (state) => state.tech >= 60 && state.round % 2 === 0,
        content: { id: 'n_tech_60', title: "💡 程序员该如何向 Prompt 工程师转型？", views: "150w", comments: 340 }
    },
    {
        condition: (state) => state.industry <= 30,
        content: {
            id: 'n_ind_30',
            title: "🔥 脉脉热议：大厂前端部门全员'毕业'",
            views: "540w", comments: 9999,
            // 🌟 选项附带 publicOpinion 效果
            choices: [
                { 
                  text: "顺应时代，不拥抱AI活该被淘汰！", 
                  // 激起民愤，舆论大跌，但技术和饭碗保住了
                  effect: { tech: +5, san: -5, publicOpinion: -20 } 
                },
                { 
                  text: "吃人血馒头，资本家不得好死！", 
                  // 迎合大众，舆论大涨，但老板看你不爽
                  effect: { san: +10, self: -10, publicOpinion: +20 } 
                }
            ]
        }
    },
    {
        condition: (state) => state.industry <= 15,
        content: { id: 'n_ind_15', title: "🚨 编程从九年义务教育中剔除，专家称“毫无意义”", views: "800w", comments: 45000 }
    },
    {
        condition: (state) => state.industry >= 80,
        content: { id: 'n_ind_80', title: "💰 AI风口大爆发，大模型微调工程师起薪突破百万！", views: "300w", comments: 800 }
    },
    {
        condition: (state) => state.stability <= 40,
        content: { id: 'n_sta_40', title: "🚨 突发：国民级应用扫码瘫痪，网友直呼退钱", views: "500w", comments: 2300 }
    },
    {
        condition: (state) => state.san <= 30,
        content: { id: 'n_san_30', title: "👁️ 网友声称在 AI 源码中发现了古巴比伦楔形文字", views: "44w", comments: 666 }
    }
];